module.exports = __webpack_public_path__ + "Roboto-Medium.894a2ede85a483bf9bed.ttf";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/font/roboto/Roboto-Medium.ttf
// module id = ../../../../../src/assets/font/roboto/Roboto-Medium.ttf
// module chunks = 29